import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TWarehousesForClientOfficeRes } from 'api/swagger';
import { CLIENT_APP_WAREHOUSES } from '../query-keys';

export const useGetWarehousesForClientOffice = () => {
  return useQuery<TWarehousesForClientOfficeRes[]>({
    queryKey: [CLIENT_APP_WAREHOUSES],
    queryFn: async () => {
      const { data } = await http.get<TWarehousesForClientOfficeRes[]>('client-office/v1/warehouses');

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
